import React from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import { TABLE_SIZES } from '../../consts';
const DensityOption = _ref => {
  let {
    setSize,
    size,
    renderIcon,
    currentSize
  } = _ref;
  return /*#__PURE__*/React.createElement(BasicButton, {
    onClick: () => setSize(size),
    style: [{
      color: size === currentSize ? theme.tokens.colors.icon.selected.value : 'inherit',
      padding: 0,
      margin: "0 0 0 18px",
      ':focus-within': {
        boxShadow: theme.halos.focus
      }
    }]
  }, renderIcon({
    size: 22
  }));
};
DensityOption.propTypes = {
  setSize: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(TABLE_SIZES)).isRequired,
  currentSize: PropTypes.oneOf(Object.values(TABLE_SIZES)).isRequired
};
export default DensityOption;
//# sourceMappingURL=DensityOption.js.map